import { FilterOptionKeys, FilterOptions, MappedFacet } from '@mybestbrands/types';
import styles from '@/app/ui/components/filters/mobile/style.module.scss';
import React, { useEffect } from 'react';
import { useTranslation } from 'next-i18next';
import clsx from 'clsx';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';

export function SortFilterMobile({ filter }: { filter: FilterOptions[FilterOptionKeys.SORTING] | undefined }) {
  const { t } = useTranslation(['filters']);
  const pathSearchParams = useSearchParams();
  const router = useRouter();
  const pathname = usePathname();

  const [filterOptions, setFilterOptions] = React.useState([] as MappedFacet[]);

  useEffect(() => {
    if (filter && filter.options.length) {
      setFilterOptions(filter.options.sort((a, b) => (a.id < b.id ? 1 : -1)));
    }
  }, [filter]);

  function onSort(option: MappedFacet) {
    const restOptions = filterOptions.filter((o) => o.id !== option.id);
    //reset their checked state
    restOptions.forEach((o) => (o.checked = false));

    const newFilterOptions = [...restOptions, { ...option, checked: !option.checked }];

    //sort by id
    newFilterOptions.sort((a, b) => (a.id < b.id ? 1 : -1));
    setFilterOptions(newFilterOptions);

    const params = new URLSearchParams(pathSearchParams ?? '');
    const page = params.get('page');

    if (page) params.delete('page');

    params.set('sort', option.value);

    const url = `${pathname}?${params.toString()}`;

    router.push(url);
  }

  return (
    <>
      <div className="mb-2">
        <strong>{t('sorting')}</strong>
      </div>
      <div className={styles.style_sorting_container}>
        {filterOptions.map((option) => (
          <button
            onClick={() => onSort(option)}
            key={option.id}
            className={`${clsx('btn medium me-2 ms-2', option.checked ? 'btn-black' : 'btn-white')} )}`}
            style={{ whiteSpace: 'nowrap', textTransform: 'none' }}>
            {t(option.name)}
          </button>
        ))}
      </div>
    </>
  );
}
